import InfoPanel from '../../components/memo.elements/info.panel';
import Button from '../../components/ui/button';
import { formatDate } from '../../scripts/helpers/get.date';
import './home.scss';

const TariffStatus = ( props ) => {

  const {

    isTariffActive = false, 
    parsingFolder = null, 
    parsingDate = null, 
    parsingNextTime = null 

  } = props;

  const companiesLink = `https://arbitr-parser-api.fullstack-freelancer.ru/storage/${ parsingFolder }/companies-results.xlsx`;
  const personsLink = `https://arbitr-parser-api.fullstack-freelancer.ru/storage/${ parsingFolder }/persons-results.xlsx`;

  return (

    <div>
    
      { !isTariffActive
        
        ?

          <div>

            <InfoPanel 
          
              color = 'warning'
              className = 'home__infopanel'
              
            >

              <p className = 'home__infopanel__title home__infopanel__text__17'>

                Оплаченный период <br />
                закончился! <br /><br />

              </p>

              <p className = 'home__infopanel__text home__infopanel__text__15'>

                продлите доступ, <br />
                чтобы получить доступ <br />
                к актуальным результатам

              </p>

            </InfoPanel>

            <Button className = 'home__button home__button__calling'>Связаться с менеджером</Button>

          </div>

        :

          <div>

            <p className = 'home__text home__text__results'>Скачать результаты парсинга:</p>

            <Button className = 'home__button'>
              <a className = 'home__link' href = { companiesLink } target = '_blank'>
                Организации
              </a>
            </Button>

            <Button className = 'home__button'>
              <a className = 'home__link' href = { personsLink } target = '_blank'>
                ИП и физ. лица
              </a>
            </Button>

            <div className = 'home__tariff__texts'>

              <p className = 'home__tariff__texts__text font-bold'>Сбор информации:</p>
              <p className = 'home__tariff__texts__text text-right font-bold'>{ parsingDate }</p>

              <p className = 'home__tariff__texts__text'>Следующий сбор:</p>
              <p className = 'home__tariff__texts__text text-right'>{ parsingNextTime }</p>

            </div>

          </div>

      }

    </div>

  );

};

export default TariffStatus;